import React from "react";

/**
 * DashboardFooter — small mono row at the bottom of the main column.
 * Version, build hash, region, copyright. Build hash is sourced from
 * REACT_APP_BUILD_HASH if set (deploy pipeline), else falls back to "dev".
 */

const DashboardFooter = () => {
  const version = process.env.REACT_APP_VERSION || "v2.4";
  const buildHash = process.env.REACT_APP_BUILD_HASH || "dev";
  const region = process.env.REACT_APP_REGION || "ap-south-1";
  const year = new Date().getFullYear();

  return (
    <footer
      className="mt-10 pt-6 border-t border-zinc-800/60 flex items-center justify-between gap-3 flex-wrap text-[10.5px] text-zinc-500 font-mono"
      data-testid="dashboard-footer"
    >
      <div className="flex items-center gap-3 flex-wrap">
        <span>RailSync {version}</span>
        <span className="w-1 h-1 rounded-full bg-zinc-700" />
        <span className="text-zinc-600">build {buildHash}</span>
        <span className="w-1 h-1 rounded-full bg-zinc-700" />
        <span className="text-zinc-600">{region}</span>
      </div>
      <span className="text-zinc-600">© {year} RailSync</span>
    </footer>
  );
};

export default DashboardFooter;
